import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import {
  applicationDocsKey,
  formUploadDocumentRoute,
} from '@features/applicationsDocs';
import axiosInstance from '@server/axiosInstance';

type UseUploadApplicationDocsProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
  applicationId: number;
};

export const useUploadApplicationDocs = ({
  setErrorText,
  applicationId,
}: UseUploadApplicationDocsProps) => {
  const client = useQueryClient();

  const { mutate: uploadDocument, isLoading: isUploadingApplicationDocument } =
    useMutation({
      mutationFn: (variables: { application_doc: any }) =>
        axiosInstance
          .post(formUploadDocumentRoute(applicationId), variables, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries([applicationDocsKey, applicationId]);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    uploadDocument,
    isUploadingApplicationDocument,
  };
};
